import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatSelect, MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../services/shared.service';
import { MatIconModule } from '@angular/material/icon';
import { hasAccess } from '../../common/permission/permission';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FilterAppLogsDialogComponent } from '../filter/filter.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter, MY_DATE_FORMATS } from '../../common/date-adapter/adapter';
import { AppLogDetailsDialogComponent } from '../detatils/details.component';
import { TruncatePipe } from '../../truncate.pipe'; 

@Component({
    selector: 'app-view-application-logs',
    imports: [
        CommonModule,
        RouterLink,
        MatCardModule,
        MatButtonModule,
        MatMenuModule,
        MatTableModule,
        MatPaginatorModule,
        NgIf,
        MatTooltipModule,
        MatSelectModule,
        MatCheckboxModule,
        FormsModule,
        MatIconModule,
        ReactiveFormsModule,
        TruncatePipe
    ],
    providers: [
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
    ],
    templateUrl: './view.component.html',
    styleUrl: './view.component.scss'
})
export class ViewApplicationLogsComponent implements OnInit {
    user: any = localStorage.getItem('user');

    loading: boolean = false;
    showExport: boolean = false;

    isToggled: boolean = false;

    filterParams: any = null;
    filterParamsArray: string[] = [];
    filterId: any = null;
    createdAt: any = null;
    quickFilterData: any;

    searchValue: string = '';

    currentPage: number = 1;
    itemsPerPage: number = 10;
    totalItems: number = 0;
    type: string = 'All';
    sortBy: string = 'created_at';
    sortOrder: string = 'desc';
    startItem: number = 0;
    endItem: number = 0;

    paginatedData: any = [];
    @ViewChild(MatPaginator) paginator: MatPaginator;

    displayedColumns: string[] = ['module', 'level', 'action', 'message', 'created_at', 'user_name', 'actions'];
    appLogsDataSource: MatTableDataSource<AppLogsData>;

    contextMenuVisible = false;
    contextMenuX = 0;
    contextMenuY = 0;
    selectedElement: any;

    configurations: any = [];
    quickFilters: any = [];
    filterVal: any = null;

    @ViewChild('exportVal') exportVal: MatSelect;

    isDarkTheme: boolean = false;

    constructor(private router: Router, public themeService: CustomizerSettingsService, private sharedService: SharedService, private toastr: ToastrService, private dialog: MatDialog) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.themeService.isDarkThemeEnabled$.subscribe((isDarkThemeEnabled: boolean) => {
            this.isDarkTheme = isDarkThemeEnabled;
        });
    }

    ngOnInit(): void {
        this.user = (JSON.parse(this.user))?.user_info;

        if (!localStorage.getItem('token')) {
            localStorage.clear();
            this.router.navigate(['']);
            return;
        }

        if (!this.user?.is_superuser) {
            this.toastr.error('You do not have permission to access this page.');
            this.router.navigate(['/dashboard']);
            return;
        }

        // ✅ Restore saved filters
        const savedFilters = localStorage.getItem('appLogsFilterParams');
        if (savedFilters) {
            this.filterParams = savedFilters;
            this.parseFilterParams();
        }

        // ✅ Restore sorting state
        const savedSortBy = localStorage.getItem('appLogsSortBy');
        const savedSortOrder = localStorage.getItem('appLogsSortOrder');

        if (savedSortBy) {
            this.sortBy = savedSortBy;
        }
        if (savedSortOrder) {
            this.sortOrder = savedSortOrder;
        }

        this.getConfigurations();
        this.getData(1);
        // this.getQuickFilters();
    }

    getConfigurations() {
        this.loading = true;
        this.sharedService.getRequest('/app_logs/configurations').subscribe((res: any) => {
            this.loading = false;
            this.configurations = (res as any).content;
        }, (err) => {
            this.loading = false;
            if (err.error.message.message === 'Please login again. Your session is expired') {
                this.toastr.error('Error: ' + err.error.message.message);
                localStorage.clear();
                this.router.navigate(['/']);
            }
            else {
                this.toastr.error('Error: ' + err.error.message);
            }
        });
    }


    getData(currentPage: number): void {
        this.loading = true;
        let endpoint = `page=${currentPage}&item_page=${this.itemsPerPage}&sort_by=${this.sortBy}&sort_by_dir=${this.sortOrder}`;
        if (this.searchValue) {
            endpoint += `&search=${this.searchValue}`;
        }

        if (this.filterParams != null || this.filterParams != undefined) {
            endpoint += `&${this.filterParams}`;
        }

        if (this.filterId != null || this.filterId != undefined) {
            endpoint += `&filter_id=${this.filterId}`
        } else if (this.createdAt != null || this.createdAt != undefined) {
            endpoint += `&created_at=${this.createdAt}`
        }

        this.sharedService.getRequest('/app_logs/all?' + endpoint).subscribe((res: any) => {
            this.loading = false;
            this.appLogsDataSource = new MatTableDataSource(res.content);
            this.paginatedData = res.pagination;
            this.totalItems = this.paginatedData.totalItems;
            this.itemsPerPage = this.paginatedData.itemsPerPage;
            this.calculateItemRange();
        }, (err) => {
            this.loading = false;
            this.toastr.error('Error: ' + err.error.message.message);
            if (err.error.message.message === 'Please login again. Your session is expired') {
                localStorage.clear();
                this.router.navigate(['/']);
            }
        });
    }

    calculateItemRange(): void {
        if (this.currentPage === 1) {
            this.startItem = 1;
        } else {
            this.startItem = (this.currentPage - 1) * this.itemsPerPage + 1;
        }
        this.endItem = Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
    }

    openConfirmDialog(id: string): void {
        const dialogRef = this.dialog.open(ConfirmDialogComponent);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.deleteData(id);
            }
        });
    }

    deleteData(id: any): void {
        this.loading = true;
        this.sharedService.deleteRequest('/app_logs/remove?id=' + id).subscribe(() => {
            this.loading = false;
            // Filter the data array to exclude the item with the matching report_id
            this.appLogsDataSource.data = this.appLogsDataSource.data.filter(
                (item: AppLogsData) => item.id !== id
            );
            this.toastr.success('Entry Deleted Successfully');
        }, (err) => {
            this.loading = false;
            this.toastr.error('Error: ' + err.error.message.message);
            if (err.error.message.message === 'Please login again. Your session is expired') {
                localStorage.clear();
                this.router.navigate(['/']);
            }
        });
    }

    goToPage(page: number): void {
        if (page !== this.currentPage) {
            this.currentPage = page;
            this.getData(this.currentPage);
        }
    }

    onRightClick(event: MouseEvent, element: any) {
        event.preventDefault();
        this.contextMenuX = event.clientX;
        this.contextMenuY = event.clientY;
        this.contextMenuVisible = true;
        this.selectedElement = element;
    }

    @HostListener('document:click', ['$event'])
    closeContextMenu(event: MouseEvent) {
        if (this.contextMenuVisible) {
            this.contextMenuVisible = false;
        }
    }

    exportFile(): void {
        this.loading = true;

        let endpoint = `format=xlsx&sortby=${this.sortBy}&sortby_dir=${this.sortOrder}`;

        if (this.searchValue) {
            endpoint += `$search=${this.searchValue}`;
        }

        if (this.filterParams != null || this.filterParams != undefined) {
            endpoint += `&${this.filterParams}`;
        }

        if (this.filterId != null || this.filterId != undefined) {
            endpoint += `&filter_id=${this.filterId}`
        } else if (this.createdAt != null || this.createdAt != undefined) {
            endpoint += `&created_at=${this.createdAt}`
        }

        this.sharedService.getRequest('/engineering/export?' + endpoint).subscribe((res: any) => {
            this.downloadFile(res.content.report);
            this.loading = false;
            this.resetExportVal();
        }, (err) => {
            this.loading = false;
            if (err.status == 449) {
                this.toastr.error('Error: ' + err.error.message);
            }
            else {
                this.toastr.error('Error: ' + err.error.message.message);
                if (err.error.message.message === 'Please login again. Your session is expired') {
                    localStorage.clear();
                    this.router.navigate(['/']);
                }
            }
            this.resetExportVal();
        });
    }

    resetExportVal(): void {
        this.exportVal.value = null;
    }

    downloadFile(url: string): void {
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.download = this.getFileNameFromUrl(url); // Optional: extract filename from URL
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    getFileNameFromUrl(url: string): string {
        return url.split('/').pop() || 'download';
    }

    toggleSort(column: string): void {
        if (this.sortBy === column) {
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortBy = column;
            this.sortOrder = 'asc'; // Default to ascending on column change
        }

        // ✅ Save sorting state
        localStorage.setItem('appLogsSortBy', this.sortBy);
        localStorage.setItem('appLogsSortOrder', this.sortOrder);

        this.getData(this.currentPage);
    }

    filterData(): void {
        if (this.filterVal != '' && this.filterVal != null && this.filterVal != undefined) {
            const quickRangeValues = ['24h', '7d', '14d', '30d', '12m', 'LY'];
            if (!quickRangeValues.includes(this.filterVal)) {
                const filterData = this.quickFilters.find((item: any) => String(item.id) === String(this.filterVal));
                this.quickFilterData = JSON.parse(filterData.filters_data);
            }
        }

        const dialogRef = this.dialog.open(FilterAppLogsDialogComponent, {
            data: {
                configurations: this.configurations,
                quickFilterData: this.quickFilterData,
                filterVal: this.filterVal
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.currentPage = 1;
            this.loading = true;
            if (this.quickFilterData != null && this.quickFilterData != undefined) {
                this.filterId = null;
            }
            else {
                this.filterVal = this.filterId;
            }
            this.createdAt = null;
            this.filterParams = result;
            if (this.filterParams?.includes('filterStatus=')) {
                // Separate filterStatus from the rest
                const params = new URLSearchParams(this.filterParams);
                const filterStatus = params.get('filterStatus');
                params.delete('filterStatus');

                const filterName = params.get('filter_name');
                params.delete('filter_name');

                // Apply replace on the remaining part
                let rest = params.toString();
                rest = rest.replace(/%20/g, ' ').replace(/%3A/g, ':');

                // Re-attach filterStatus if needed
                if (filterStatus !== null) {
                    rest += `&filterStatus=${filterStatus}`;
                }

                this.filterParams = rest;

                if (filterStatus == 'Save') {
                    this.saveFilters(this.filterParams, filterName)
                }
                else {
                    this.updateFilters(this.filterParams, filterName)
                }
            } else {
                // No filterStatus, so just replace directly
                this.filterVal = null;
                this.filterParams = this.filterParams?.replace(/%20/g, ' ').replace(/%3A/g, ':');
            }

            if (this.filterParams) {
                localStorage.setItem('appLogsFilterParams', this.filterParams);
            } else {
                localStorage.removeItem('appLogsFilterParams');
            }

            this.parseFilterParams();
            this.getData(this.currentPage);
            // this.getQuickFilters();
            this.loading = false;
        });
    }

    parseFilterParams() {
        this.filterParamsArray = [];

        // Split the query string into key-value pairs
        const pairs = this.filterParams?.split('&');

        // Loop through each pair and format the key
        for (const pair of pairs || []) {
            if (pair?.includes('filterStatus=') || pair?.includes('filter_name=')) {
                continue; // skip this one
            }

            const [key, value] = pair.split('=');

            const formattedKey = key
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (char: string) => char.toUpperCase());

            this.filterParamsArray.push(formattedKey);
        }

    }

    saveFilters(filterParams: any, filterName: any) {
        const params = new URLSearchParams(filterParams);
        params.delete('filterStatus');
        params.delete('filter_name');

        // Convert URLSearchParams to a plain object
        const obj: { [key: string]: string } = {};
        params.forEach((value, key) => {
            obj[key] = value;
        });

        // Convert object to JSON string
        const jsonString = JSON.stringify(obj);

        let data = {
            filter_name: filterName,
            module_name: "engineering",
            filters_data: jsonString
        };

        this.sharedService.postRequest('/filters/save', data).subscribe((res: any) => {
            this.loading = false;
            this.filterVal = res.id;
            this.toastr.success('Filters Saved Successfully');
            this.getQuickFilters();
        }, (err) => {
            this.loading = false;
            this.toastr.error('Error: ' + err.error.message.message);
            if (err.error.message.message === 'Please login again. Your session is expired') {
                localStorage.clear();
                this.router.navigate(['/']);
            }
        });
    }

    updateFilters(filterParams: any, filterName: any) {
        const params = new URLSearchParams(filterParams);
        params.delete('filterStatus');
        params.delete('filter_name');

        // Convert URLSearchParams to a plain object
        const obj: { [key: string]: string } = {};
        params.forEach((value, key) => {
            obj[key] = value;
        });

        // Convert object to JSON string
        const jsonString = JSON.stringify(obj);

        let data = {
            id: this.filterVal,
            filter_name: filterName,
            module_name: "engineering",
            filters_data: jsonString
        };

        this.sharedService.postRequest('/filters/update', data).subscribe((res: any) => {
            this.loading = false;
            this.toastr.success('Filters Updated Successfully');
            this.getQuickFilters();
        }, (err) => {
            this.loading = false;
            this.toastr.error('Error: ' + err.error.message.message);
            if (err.error.message.message === 'Please login again. Your session is expired') {
                localStorage.clear();
                this.router.navigate(['/']);
            }
        });
    }

    resetSearch() {
        this.searchValue = '';
        this.getData(1); // Optionally call this method to update shifts when search is cleared
    }

    getQuickFilters() {
        this.loading = true;
        this.sharedService.getRequest('/filters/all?module_name=engineering').subscribe((res: any) => {
            this.loading = false;
            this.quickFilters = (res as any).content;
        }, (err) => {
            this.loading = false;
            if (err.error.message.message === 'Please login again. Your session is expired') {
                this.toastr.error('Error: ' + err.error.message.message);
                localStorage.clear();
                this.router.navigate(['/']);
            }
            else {
                this.toastr.error('Error: ' + err.error.message);
            }
        });
    }

    onQuickFilterChange(event: MatSelectChange) {
        this.filterParamsArray = [];
        this.filterParams = null;

        const val = event.value;

        if (val == 'null') {
            this.filterId = null;
            this.createdAt = null;
            this.getData(1);
            return;
        }

        const quickRangeValues = ['24h', '7d', '14d', '30d', '12m', 'LY'];
        if (!quickRangeValues.includes(val)) {
            this.createdAt = null;
            this.filterId = val;
            const filterData = this.quickFilters.find((item: any) => String(item.id) === String(this.filterId));
            const parsedFiltersData = JSON.parse(filterData.filters_data);
            this.filterParams = Object.entries(parsedFiltersData)
                .filter(([_, value]) => value !== '' && value !== null && value !== undefined)
                .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
                .join('&');
        } else {
            this.createdAt = val;
            this.filterId = null;
        }

        this.parseFilterParams();
        this.getData(1);
    }

    onRowDoubleClick(row: any) {
        this.getAppLogDetailsDialog(row.id);
    }

    getAppLogDetailsDialog(id: string) {
        this.loading = true;
        this.sharedService.getRequest('/app_logs/details?id=' + id).subscribe((res: any) => {
            this.loading = false;
            const dialogRef = this.dialog.open(AppLogDetailsDialogComponent, {
                data: {
                    appLogDetails: res.content
                }
            });
        }, (err) => {
            this.loading = false;
            this.toastr.error('Error: ' + err.error.message.message);
            if (err.error.message.message === 'Please login again. Your session is expired') {
                localStorage.clear();
                this.router.navigate(['/']);
            }
        });
    }
}

export interface AppLogsData {
    id: string
    module: string
    level: string
    action: string
    message: string
    extra_data: string
    created_at: string
    user_name: string
}